import { render } from "./Stats.vue?vue&type=template&id=0782ad3b&scoped=true&ts=true"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"

import "./Stats.vue?vue&type=style&index=0&id=0782ad3b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0782ad3b"]])

export default __exports__